








/* Created- 25 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import { UserModel, AccountClient } from "../Generated/ParticaAPI";
import { ButtonConfig, ButtonType } from "../Models/Buttons";

import ParticaBaseView from "../Views/Base/ParticaBaseView.vue";
import { AccountToken } from "./customauthservice";
import ResetPasswordForm from "@/Ui-Components/Account/ResetPasswordForm.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
@Component(
	{
		name: "ResetPassword",
		components: { ParticaError, ResetPasswordForm, ParticaRowContainer, ParticaCard }
	})
export default class ResetPassword extends ParticaBaseView {
	private svc: AccountClient;
	private userid: string = "";
	private resetcode: string = "";
	private data: UserModel = new UserModel();
	private resetbuttons: ButtonConfig[] = [
		{ label: "Reset Password", action: eParticaAction.ACCOUNT_RESET_PASSWORD, type: ButtonType.OK } as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.ACCOUNT_RESET_PASSWORD: {
					await this.svc.resetPassword(this.resetcode, this.userid, this.data.password);
					this.ShowSnackbar("Password reset, Login with your new password to continue.");
					this.navigate("login", undefined);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.svc = new AccountClient();
		this.init();
	}

	private async init() {
		try {
			this.resetcode = this.$route.query.code as string;
			this.userid = this.$route.query.id as string;
		} catch (error) {
			this.ShowErrorDialog(error, "An error occured confirming your email. Try again.");
		}

	}
}
